<template>
  <div
    id="callNowModal"
    class="modal modal-geq"
    :class="{ 'is-active': active }"
    @keydown.esc.prevent="closeModal()"
  >
    <div
      class="modal-background"
      @click.prevent="closeModal()"
    />
    <div class="modal-card">
      <div class="modal-form">
        <div class="modal-card-head">
          <p class="modal-card-title">
            Call Now
          </p>
          <button
            class="modal-card-close bg-transparent"
            aria-label="close"
            @click.prevent="closeModal()"
          >
            <i class="fa fa-times fa-lg" />
          </button>
        </div>
        <div class="modal-card-body">
          <div class="call-info-container">
            <p class="call-info-text">
              For the best prices and availability, call us now on
            </p>
            <p class="call-info-days">
              Monday - Friday
            </p>
            <p class="call-info-number">
              <i class="fas fa-phone" />
              <a 
                :href="'tel:' + phoneNumber" 
                :aria-label="`Call ${phoneNumber} to Book`"
              >
                {{ phoneNumber }}
              </a>
            </p>
            <p class="call-info-action">
              Call to Book
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../vue-functions/event-bus';
import { closeModal } from '../../modals/closeModal';

export default {
  data() {
    return {
      active: false,
      phoneNumber: ''
    };
  },
  created() {
    this.setPhoneNumberFromRegion();

    EventBus.$on('TOGGLE_CALL_NOW_MODAL', () => {
      document.documentElement.classList.add('is-clipped');
      this.show();
    });
  },
  mounted() {
    closeModal(this.closeModal);
  },
  methods: {
    setPhoneNumberFromRegion() {
      const path = window.location.pathname;
      const regionMatch = path.match(/^\/(en-(us|au|ca|gb))/i);

      const regionCode = regionMatch ? regionMatch[1].toLowerCase() : null;

      const regionMap = {
        'en-us': '(877) 789-3558',
        'en-au': '1300 321 962',
        'en-ca': '1-844-915-3555',
        'en-gb': '0808 169 8807'
      };

      this.phoneNumber = regionMap[regionCode] || '(877) 789-3558';
    },
    show() {
      this.active = true;
      this.toggleBodyClass();
    },
    toggleBodyClass() {
      let bodyEl = document.querySelector('body');
      bodyEl.classList.toggle('is-modal-active');
    },
    closeModal() {
      this.active = false;
      document.documentElement.classList.remove('is-clipped');
      this.toggleBodyClass();
    }
  }
};
</script>
